import api from './axios';

export async function export_beneficiaries_to_excel(beneficiaryIds = [], filters = {}) {
    try {
        let res = await api.post(`/excel/export`, { beneficiaryIds, ...filters });
        res = res.data;
        return res;
    }
    catch (err) {
        throw err;
    }
}

export async function import_data_from_excel(parsedData) {
    try {
        let res = await api.post(`/excel/import`, parsedData);
        res = res.data;
        
        return res;
    }
    catch (err) {
        
        // Enhanced error handling
        if (err.response?.data) {
            const errorData = err.response.data;
            throw new Error(errorData.message || errorData.error || 'שגיאה בייבוא הנתונים');
        } else if (err.response?.status === 413) {
            throw new Error('הקובץ גדול מדי. אנא חלק את הנתונים לקבצים קטנים יותר.');
        } else if (err.response?.status >= 500) {
            throw new Error('שגיאת שרת. אנא נסה שוב מאוחר יותר.');
        } else {
            throw new Error('שגיאה בתקשורת עם השרת');
        }
    }
}
